import ShopItemsView from "../../components/shopItemsView/shopItemsView";

const UsedItemsOwnerView = () => {
    return (
        <div>
            <ShopItemsView update="/used-item-update" deleteurl="/Used-Items-Bussines-Profile" urlone="/Used-Items-Bussines-Profile"/>
        </div>
    )
}
export default UsedItemsOwnerView;